<template>
  <div class="reelbuzz">
    <div class="header">
        <div class="header-menu">
            <div class="header-left">
                <img src="../assets/logo.png" alt="logo-icon">
                <p>Crédito Sin Fronteras, S.A.P.I. de C.V., SOFOM, E.N.R..</p>
            </div>
            <div class="header-right">
              <li v-for="section in sections" :key="section.id" class="menu">
                <a :href="'#' + section.id" @click="gotoMEnu(section.id)" :class="{ 'active': section.id === currentSection }">{{ section.title }}</a>
              </li>
            </div>
        </div>
    </div>
    <div class="reelbuzz-content" >
      <div class="reelbuzz-box" id="section1">
        <div class="header-box" >
          <p class="name"> <span style="color:#DDF247">Las soluciones financieras</span> <br>acercan sus sueños un paso más</p>
          <!-- <p class="name">achieve success.</p> -->
          <p class="title">Servicios financieros diversificados para satisfacer las diferentes necesidades de personas y empresas.</p>
        </div>
      </div>
    </div>


    <div class="section2box" id="section2">
      <div class="section2boxmax">
        Nuestras ventajas
      </div>
      <div class="section2boxmin">
        Razones para elegirnos
      </div>
      <div class="section2boxcard">


      <div class="section2boxleft">
        <div class="section2boxleftitem">
          <div class="section2boxleftitemmax">
            Servicios diversos y soluciones flexibles
          </div>
          <div class="section2boxleftitemmin">
            Soluciones personalizadas de gestión y soporte de fondos a medida según las diferentes necesidades de los clientes.
          </div>
        </div>
        <div class="section2boxleftitem">
          <div class="section2boxleftitemmax">
Respuesta rápida y servicio profesional.
          </div>
          <div class="section2boxleftitemmin">
            Proceso de servicio eficiente y soporte total de un equipo profesional.
          </div>
        </div>
        <div class="section2boxleftitem">
          <div class="section2boxleftitemmax">
            Gestión de transparencia e integridad
          </div>
          <div class="section2boxleftitemmin">
            Permita que los clientes comprendan claramente su flujo de capital y estructura de costos en cada paso.
          </div>
        </div>
        <div class="section2boxleftitem">
          <div class="section2boxleftitemmax">
            Soporte tecnológico innovador
          </div>
          <div class="section2boxleftitemmin">
            Aplicar la última tecnología para optimizar la experiencia del cliente, agilizar los procesos y mejorar la eficiencia.
          </div>
        </div>

      </div>
      <div class="section2boxright">
        <img src="../assets/rightcard.png" alt="">
      </div>
         </div>
    </div>
    <div class="appboxs">
      <div class="apptitle">Nuestra aplicación</div>
      <div class="appboxscard">
        <div class="appboxscardleft">
          <img src="../assets/app.png" alt="">
        </div>
        <div class="appboxscardright">
         <h3>Crédito Sin Fronteras</h3>
Préstamo fácil, sin preocupaciones! Nuestra aplicación le brinda servicios de préstamos rápidos y transparentes, combinando inteligentemente la mejor solución para satisfacer todas sus necesidades. No es necesario realizar procedimientos complicados, solo unos pocos pasos y, después de la aprobación, tendrá los fondos inmediatamente. Utilizamos tecnología de encriptación avanzada para proteger cada transacción que realiza, con tarifas transparentes y sin cargos ocultos. No importa dónde se encuentre, puede disfrutar de servicios convenientes en cualquier momento y en cualquier lugar, y los métodos de pago flexibles lo hacen sentir relajado y sin estrés. ¡Descárgalo ahora y comienza tu viaje de préstamo exclusivo!<br><br>

<div style="color:#9e6ffc">
  <h3  style="color:#9e6ffc">Información básica</h3>

Nombre de la APP: Cashmore <br>
APP ID: 6755801642<br>
APPLE ID: service@cashmoretech.com<br>
Sitio oficial de la App: https://cashmoretech.com/ <br>
Nombre de la Empresa: CRÉDITO SIN FRONTERAS, S.A.P.I. de C.V., SOFOM, E.N.R.<br>
RFC de la empresa: CSF2410021TA<br>
Domicilio social: Calle Lago Zurich 219, Piso 12, Colonia Ampliación Granada, Miguel Hidalgo, Ciudad de México, C.P. 11529<br>
</div>

<br><br>
<h4>7 ventajas que te mereces:</h4>
<div class="item">
  <img src="../assets/true.png" alt=""> Aplicación conveniente: Los usuarios pueden enviar solicitudes de préstamos a través de teléfonos móviles o computadoras en cualquier momento y en cualquier lugar, sin tener que ir a bancos o instituciones crediticias, ahorrando tiempo y esfuerzo.<br>
</div>
<div class="item">
  <img src="../assets/true.png" alt="">Proceso simplificado: no se requieren entrevistas ni documentos engorrosos. El proceso de solicitud es más simple y la revisión y emisión del préstamo son más rápidas.<br>
</div>
<div class="item">
  <img src="../assets/true.png" alt="">Aprobación y emisión rápida de préstamos: a través del proceso de revisión automatizado, la aprobación se puede completar en poco tiempo y los fondos se pueden transferir rápidamente a la cuenta del prestatario.<br>
</div>
<div class="item">
   <img src="../assets/true.png" alt="">Mayor flexibilidad: con una amplia gama de productos, los usuarios pueden elegir diferentes montos de préstamo, tasas de interés y períodos de pago según sus necesidades personales y disfrutar de términos de préstamo/AVBNM más flexibles.<br>
</div>
<div class="item"><img src="../assets/true.png" alt="">Alta transparencia: la plataforma proporciona descripciones claras de las tarifas y tasas de interés, lo que permite a los usuarios comprender completamente el costo del préstamo antes de solicitarlo y evitar tarifas ocultas.<br></div>
<div class="item">
  <img src="../assets/true.png" alt="">Sin restricciones geográficas: No hay restricciones geográficas. Los prestatarios pueden solicitar préstamos a instituciones financieras en cualquier lugar, sin importar dónde se encuentren.<br>
</div>
<div class="item">
  <img src="../assets/true.png" alt="">Servicio 24/7: La plataforma generalmente brinda servicio en línea las 24 horas y los usuarios tienen la oportunidad de enviar solicitudes o verificar el progreso en cualquier momento, lo que mejora en gran medida la accesibilidad del servicio.
</div>

        </div>
      </div>
    </div>
   <div class="section3box" id="section3">
    <div class="section3boxleft">
      <img src="../assets/leftcard.png" alt="">
    </div>
    <div class="section3boxright">
      <div class="section3boxrightmax">Nuestros servicios</div>
      <div class="section3boxrightmin">Servicios financieros integrales y personalizados</div>
      <div class="section3boxrightitem">
        <div class="left">1</div>
        <div class="right">
          <div class="max">Financiación y apoyo financiero</div>
          <div class="min">Ya sea que se trate de un sueño personal o de un crecimiento empresarial, brindamos soluciones de apoyo financiero personalizadas para ayudarlo a alcanzar sus objetivos.</div>
        </div>
      </div>
      <div class="section3boxrightitem">
        <div class="left">2</div>
        <div class="right">
          <div class="max">Gestión y optimización de fondos</div>
          <div class="min">Brindar servicios de optimización de activos y administración de fondos para individuos y empresas para ayudar a los clientes a utilizar los fondos de manera eficiente y reducir la presión financiera.
</div>
        </div>
      </div>
      <div class="section3boxrightitem">
        <div class="left">3</div>
        <div class="right">
          <div class="max">Gestión de riesgos y consultoría financiera
</div>
          <div class="min">Nuestro equipo profesional brinda asesoramiento sobre planificación financiera y control de riesgos para proteger a los clientes en cada paso de su uso de capital.</div>
        </div>
      </div>
      <div class="section3boxrightitem">
        <div class="left">4</div>
        <div class="right">
          <div class="max"> Servicios digitales de control de riesgos</div>
          <div class="min">Las herramientas de gestión de riesgos simples y fáciles de usar ayudan a los clientes a controlar la seguridad patrimonial en tiempo real y brindan educación sobre riesgos a través de informes de análisis profesionales</div>
        </div>
      </div>
    </div>
   </div>

    <div class="section4box" id="section4">
      <div class="section4boxmax">
        Sobre nosotros
      </div>
      <div class="section4boxmin">
        Ayude a los clientes a alcanzar sus objetivos patrimoniales <br> con profesionalismo y amplia experiencia en el mercado.
      </div>
      <div class="section4boxcard">
        <div class="section4boxcardleft">
          Somos una empresa dedicada a brindar soluciones financieras profesionales, eficientes y personalizadas, cubriendo los campos de gestión de inversiones, planificación financiera, gestión de riesgos y finanzas corporativas. Defendemos nuestros valores fundamentales de integridad, innovación y excelencia para crear un camino hacia el crecimiento financiero a largo plazo para nuestros clientes. Ya sea que se trate de gestión de patrimonio personal o planificación financiera empresarial, podemos brindarle apoyo integral y asesoramiento estratégico.
        </div>
        <div class="section4boxcardright">
          <img src="../assets/compy.png" alt="">
        </div>
      </div>
    </div>

    <div class="section5box" id="section5">
        <div class="section5boxmax">
          Regulación y Certificaciones
        </div>
        <div class="section5logo">
          <img src="../assets/cnbv.png" alt="">
        </div>
        <div class="section5boxmin">
          Con el afán de velar por la protección de nuestros clientes, además de incrementar la seguridad para evitar delitos como el de lavado de dinero, seguimos la regulación de organismos como la Comisión Nacional Bancaria y de Valores (CNBV) y la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (CONDUSEF).
        </div>
        <div class="chartbox">
          <div class="chartboxleft">
            <img src="../assets/cloud.png" alt="">
            <div class="chartboxleftmax">
              Contáctenos
            </div>
            <div class="chartboxleftmi">
              Si tienes alguna pregunta,
Simplemente complete el formulario y nos comunicaremos con usted en breve.
            </div>
          </div>
          <div class="chartboxright">
            <p>Nombre</p>
            <input type="text" id="name" v-model="form.name">
             <p>Correo</p>
            <input type="text" id="name" v-model="form.email">
             <p>Contenido</p>
            <input type="text" id="name" v-model="form.content">
            <label class="form-check">
              <input type="checkbox" v-model="form.consentSMS">
              <span>Doy mi consentimiento para recibir mensajes de marketing por SMS/RCS.</span>
            </label>
            <label class="form-check">
              <input type="checkbox" v-model="form.consentPrivacy">
              <span>Al hacer clic en el botón, aceptas la <a @click.prevent="$router.push({name:'policy'})" href="#">política de privacidad</a> de Crédito Sin Fronteras, S.A.P.I. de C.V., SOFOM, E.N.R.</span>
            </label>
            <div class="btns" @click="submitdata()">
              Entregar
            </div>
          </div>
        </div>
    </div>



  <div class="footbox">
    <div class="footboxcard">
      <div class="footboxcarditem">
        <img src="../assets/address.png" alt="">
        Dirección: Lago Zurich 219, Piso 12, Colonia Ampliación Granada, <br> Miguel Hidalgo, Ciudad de México, C.P. 11529
      </div>
      <div class="footboxcarditem">
        <img src="../assets/email.png" alt="">
       Correo electrónico: support@creditosinfronteras.com
      </div>
    </div>
    <div class="footcopy">
      © Crédito Sin Fronteras, S.A.P.I. de C.V., SOFOM, E.N.R.
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      form:{ consentSMS: false, consentPrivacy: false },
      type: 1,
      sections: [
        { id: 'section1', title: 'Inicio' },
        { id: 'section2', title: 'Nuestras ventajas' },
        { id: 'section3', title: 'Nuestros servicios' },

        { id: 'section4', title: 'Sobre nosotros' },
        { id: 'section5', title: 'Contáctenos' },
         { id: 'policy', title: 'Política de privacidad' },
         { id: 'terms', title: 'Términos y Condiciones' },
      ],
      currentSection: ''
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    submitdata(){
      if(!this.form.name){
        alert('Por favor ingresa Nombre')
        return
      }
      if(!this.form.email){
        alert('Por favor ingresa Correo')
        return
      }
      if(!this.form.content){
        alert('Por favor ingresa Contenido')
        return
      }
      if(!this.form.consentSMS){
        alert('Debes dar tu consentimiento para recibir mensajes de marketing por SMS/RCS.')
        return
      }
      if(!this.form.consentPrivacy){
        alert('Debes aceptar la política de privacidad para continuar.')
        return
      }
      alert('Envío exitoso')
      this.form.name=""
      this.form.email=""
      this.form.content=""
      this.form.consentSMS=false
      this.form.consentPrivacy=false
    },
    gotoAPP(){
      window.open('https://apps.apple.com/mx/app/id6737598795')
    },
    scrollToSection(id) {
      this.currentSection = id;
      const targetSection = document.getElementById(id);
     c
    },
    handleScroll() {
      const scrollPosition = window.scrollY;
      this.sections.forEach(section => {
        const targetSection = document.getElementById(section.id);
        if (targetSection.offsetTop <= scrollPosition && targetSection.offsetTop + targetSection.offsetHeight > scrollPosition) {
          this.currentSection = section.id;
        }
      });
    },
    gotoMEnu(id) {
      if(id=='policy'){
        this.$router.push({ name:'policy' })
        return
      }
      if(id=='terms'){
        this.$router.push({ name:'terms' })
        return
      }
      const targetElement = document.getElementById(id);
        if (targetElement) {
          const targetPosition = targetElement.offsetTop + 50;
          const startPosition = window.pageYOffset;
          const distance = targetPosition - startPosition;
          const duration = 500; // 滚动持续时间，单位毫秒
          let startTime = null;

          function animation(currentTime) {
            if (startTime === null) {
              startTime = currentTime;
            }
            const timeElapsed = currentTime - startTime;
            const run = ease(timeElapsed, startPosition, distance, duration);
            window.scrollTo(0, run);
            if (timeElapsed < duration) {
              requestAnimationFrame(animation);
            }
          }

          function ease(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
          }

          requestAnimationFrame(animation);
        }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style lang="less" scoped>
.color-fff {
  color:#fff;
}
.color-000 {
  color:#000;
}
.color-595 {
  color:#595566 ;
}
.header {
    position: fixed;
    width: 100%;
    z-index: 999;
    background: none;
    transition: 0.5s;

    background: #101010;
    color: #fff;

    .header-menu {
        width: 100%;
        height: 100px;

        margin: 0 auto;


        .header-left {
            height: 80px;
            width: 100%;
            display: flex;
            align-items: center;

           justify-content: center;
            img {
                width: 40px;
                height: 40px;
                margin-right: 20px;
            }

            p {
                height: 40px;
                font-family: Scada, Scada;
                font-weight: bold;
                font-size: 22px;
                color: #fff;
                line-height: 38px;
            }
        }

        .header-right {
          width: 100%;
          padding: 0 20%;
          padding-bottom:20px;
            height: 50px;
             line-height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
  background: #101010;
  box-sizing: border-box;
    color: #fff;
            .menu {

                margin: 0 10px;

                font-weight: 400;
                font-size: 16px;
                text-align: center;

                cursor: pointer;
                box-sizing: border-box;

                a {
                  color: #fff;
                  padding: 8px 10px;
                }

                .active {
                  color: #000;
                  cursor: pointer;
                }
            }

            .menu:last-child {
                margin-right: 0;
            }

            .active {
                font-weight: 900;
                color: #000;
                border-radius: 20px;
                background: #DDF247;
                transition: all 0.8s;

            }
            .active a{
              color: #000;
            }
        }
    }
}
.reelbuzz-content {
  padding-top: 130px;

  .reelbuzz-box {
    width: 100%;
    height: 800px;
    background: url(../assets/bannel.png) center top no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    box-sizing: border-box;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .header-box {
      width: 1220px;
      height: 100%;
      margin: 0 auto;
      padding-top: 195px;
      box-sizing: border-box;
      padding-right: 500px;
      .name {
        font-weight: bold;
        font-size: 50px;
        color: #fff;
        line-height: 70px;
        margin-bottom: 32px;
      }
      .title {
        font-family: Roboto, Roboto;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 26px;
      }
    }
  }
}
.appboxs{
  margin-top:100px ;
   width: 70%;
    margin-left: 15%;
    .apptitle{
      font-size: 40px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 50px;
    }
    .appboxscard{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .appboxscardleft{
        width: 35%;
        img{
          width: 100%;
        }
      }
      .appboxscardright{
        width: 60%;
        font-size: 14px;
        color: #888;
        line-height: 1.6;
        h3,h4{
          margin-bottom: 10px;
          color: #000;
          font-weight: bold;

        }
        .item{
          margin-bottom: 10px;
          display: flex;
          align-items: top;
          img{
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
        }
      }
    }
}
.section5box{
  margin-top:100px ;
  width: 70%;
  margin-left: 15%;
  margin-bottom: 100px;
  .section5boxmax{
    font-size: 46px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 60px;
  }
  .section5logo{
    width: 600px;
    margin: 0 auto;
    img{
      width: 100%;
    }
  }
  .section5boxmin{
    font-size: 20px;
    text-align: center;
    color: #888;
    line-height: 1.6;
    margin-top: 30px;
  margin-bottom: 30px;
}
.chartbox{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 66px;
  .chartboxleft{
    width: 40%;
    img{
      width: 150px;
      margin-bottom: 20px;
    }
    .chartboxleftmax{
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .chartboxleftmi{
      font-size: 18px;
      line-height: 1.6;
    }
  }
  .chartboxright{
    width: 40%;
    p{
      font-size: 20px;
      color: #888;
      margin-bottom: 10px;
    }
    input{
      width: 100%;
      height: 40px;
      line-height: 40px;
      border: none;
      background: #F8F8F8;
      border-radius: 6px 6px 6px 6px;
      border: 1px solid #E4E4E4;
      margin-bottom: 20px;
      padding-left: 12px;
    }
    .form-check {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      margin-bottom: 14px;
      cursor: pointer;
      font-size: 16px;
      color: #555;
      line-height: 1.5;
      input[type="checkbox"] {
        flex-shrink: 0;
        margin-top: 3px;
        width: 18px;
        height: 18px;
        accent-color: #DDF247;
        cursor: pointer;
      }
      a {
        color: #9e6ffc;
        text-decoration: none;
        &:hover { text-decoration: underline; }
      }
    }
    .btns{
      width: 120px;
      height: 40px;
      background: #DDF247;
      text-align: center;
      line-height: 40px;
      border-radius: 10px;
      font-size: 20px;
      cursor: pointer;
    }
  }
}
}
.section4box{
   margin-top:100px ;
   width: 100%;
    padding:60px 15%;
    box-sizing: border-box;
    background-image: url(../assets/combg.png);
    background-size: 100% 100%;
    .section4boxmax{
      font-size: 40px;
      font-weight: bold;
      color: #fff;
      margin-bottom: 10px;
      text-align: center;
    }
    .section4boxmin{
      font-size: 20px;
      color: #888;
      line-height: 1.8;
      margin-bottom: 50px;
      text-align: center;
    }
    .section4boxcard{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .section4boxcardleft{
        font-size: 18px;
        color: #fff;
        line-height: 1.8;
        width: 50%;
      }
      .section4boxcardright{
        width: 40%;
        img{
          width: 100%;
        }
      }
    }
}
.section3box{
  padding-top:100px ;
   width: 70%;
    margin-left: 15%;
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .section3boxleft{
      width: 40%;
      img{
        width: 100%;
      }
    }
    .section3boxright{
      width: 45%;
      .section3boxrightmax{
         font-size: 40px;
        font-weight: bold;
    margin-bottom: 15px;

      }
      .section3boxrightmin{
        color: #888;
        font-size: 20px;
        margin-bottom: 20px;
      }
      .section3boxrightitem{
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        .left{
          width: 50px;
          height: 50px;
          text-align: center;
          line-height: 50px;
          border-radius: 25px;
          background: #DDF247;
          font-size: 26px;
          margin-right: 6px;
        }
        .right{
          width: calc(100% - 70px);
          .max{
            font-size: 18px;
            font-weight: bold;
            color: #000;
            margin-bottom: 10px;
          }
          .min{
            color: #888;
            line-height: 1.4;
            font-size: 16px;
          }
        }
      }
    }
}
.section2box{
  padding-top:100px ;
  .section2boxmax{
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #000;
  }
  .section2boxmin{
     text-align: center;
    font-size: 20px;
    margin-top: 10px;
    color: #737373;
  }
  .section2boxcard{
    width: 70%;
    margin-left: 15%;
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .section2boxleft{
      width: 45%;
      padding-left: 20px;
      border-left: 3px solid #ccc;
      .section2boxleftitem{
        margin-bottom: 26px;
        cursor: pointer;
        .section2boxleftitemmax{
          font-size: 24px;
          margin-bottom: 10px;
          color: #888;
        }
        .section2boxleftitemmin{
          font-size: 16px;
          margin-bottom: 10px;
          color: #888;
        }
      }
      .section2boxleftitem:hover{
       .section2boxleftitemmax{
        color: #000;
         transition: 0.5s;
       }

      }
    }
    .section2boxright{
      width: 40%;
      img{
        width: 100%;
      }
    }
  }
}
.audit-box {
  width: 100%;
  height: 480px;

  .audit {
    width: 1320px;
    height: 100%;
    margin: 0 auto;
    box-sizing: border-box;

    .education-box {
      width: 100%;
      height: 460px;
      margin-top: -98px;
      margin-bottom: 140px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .education {
        width: 420px;
        height: 100%;
        background: #fff ;
        box-shadow: 0px 12px 24px 0px rgba(0,0,0,0.08);
        padding: 50px 40px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .img-box {
          width: 100%;
          height: 80px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;

          img {
            width: 80px;
            height: 80px;

          }

          .img-number {
            font-family: Kavivanar, Kavivanar;
            font-weight: 400;
            font-size: 80px;
            color: #E8E8E8;
            line-height: 118px;
          }
        }


        .education-name {
          width: 100%;
          padding-top: 34px;
          box-sizing: border-box;
          border-top: 1px solid #E8E8E8;
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          line-height: 28px;
          margin-bottom: 16px;
        }
        .education-title {
          width: 100%;
          font-weight: 400;
          font-size: 18px;
          color: #999999;
          line-height: 30px;
        }
      }

      .education:hover {
        background:#4850D5;

        .education-name {
          color: #fff;
        }

        .education-title {
          color: rgba(255,255,255,0.8);
        }
      }
    }

  }
}


.choose-us-box {
  height: 740px;
  width: 100%;
  margin-bottom: 120px;
  .choose-us {
    width: 1320px;
    height: 100%;
    padding-top: 120px;
    box-sizing: border-box;
    box-sizing:border-box ;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .choose-us-left {
      width: 704px;
      height: 620px;
      margin-left: -58px;
      transition: all 0.8s;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .choose-us-left:hover {
      transform: rotateX(20deg);
    }

    .choose-us-right {
      width: 600px;
      height: 100%;
      padding-top: 26px;
      box-sizing: border-box;

      .choose-us-name {
        font-weight: bold;
        font-size: 54px;
        color: #333333;
        line-height: 64px;
        margin-bottom: 20px;
      }

      .choose-us-title {
        font-weight: 400;
        font-size: 18px;
        color: #999999;
        line-height: 30px;
        margin-bottom: 90px;
      }
      .choose {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 120px;
        width: 598px;
        margin-bottom: 42px;

        .choose-box {
          width: 267px;
          height: 120px;

          .choose-img-box{
            width: 267px;
            height: 30px;
            display: flex;
            margin-bottom: 18px;

            img {
              width: 30px;
              height: 30px;
              margin-right: 14px;
            }

            .choose-img-title {
              font-weight: bold;
              font-size: 20px;
              color: #333333;
              line-height: 30px;
            }
          }

          .choose-name {
            font-weight: 400;
            font-size: 18px;
            color: #999999;
            line-height: 30px;
          }
        }
      }
    }
  }
}
.nuestros-box{
   width: 100%;
    height: 1100px;
  // background: url(../assets/card1.png) center center no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding:300px 800px 300px 200px;
  font-size: 18px;
  .nuestros-boxmax{
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 50px;
  }
  .nuestros-box-itemleftheader{
    display: flex;
    justify-content: left;
    margin-bottom: 40px;
    .nuestros-box-itemleftheaderleft{
      img{


        width: 140px;
        margin-right: 40px;
      }
    }
    .nuestros-box-itemleftheaderright{
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 30px;
      img{
        margin-top: 30px;
        width: 200px;
        cursor: pointer;
      }
    }
  }
}

.services-box {
  width: 100%;
  height: 758px;
  // background: url(../assets/serviceBg.png) center center no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;

  .services {
    height: 100%;
    width: 1320px;
    margin: 0 auto;
    box-sizing: border-box;

    .services-block {
      width: 100%;
      height: 150px;
    }

    .service-title {
      font-weight: bold;
      font-size: 54px;
      color: #333333;
      line-height: 63px;
      text-align: center;
      margin-bottom: 76px;
    }

    .item-service-box {
      width: 100%;
      height: 280px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item-service {
        width: 314px;
        height: 280px;
        padding: 50px 30px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 0px 12px 24px 0px rgba(0,0,0,0.08);
        border-radius: 20px;
        transition: all 0.8s;

        img {
          width: 86px;
          height: 80px;
          margin-bottom: 20px;
        }
        .item-service-title {
          font-weight: bold;
          font-size: 22px;
          color: #333333;
          line-height: 36px;
          text-align: left;
        }
      }

      .item-service:hover {
        transform: translateY(-30px);
      }
    }
  }
}

.contact-box {
  width: 100%;
  height: 905px;

  .contact {
    width: 1320px;
    height: 100%;
    margin: 0 auto;
    padding-top: 150px;
    box-sizing: border-box;

    .contact-title {
      width: 100%;
      font-weight: bold;
      font-size: 54px;
      color: #333333;
      line-height: 63px;
      text-align: center;
      margin-bottom: 72px;
    }

    .contact-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;

      .offer-box {
        width: 414px;
        height: 100%;

        .offer-img {
          width: 414px;
          height: 270px;
          overflow: hidden;
          margin-bottom: 35px;

          img {
            width: 414px;
            height: 270px;
            transition: all 0.8s;
          }

          img:hover {
            transform: scale(1.2);
          }
        }

        .offer-title {
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          line-height: 28px;
          text-align: left;
          margin-bottom: 20px;
        }

        .offer-name {
          font-weight: 400;
          font-size: 18px;
          color: #999999;
          line-height: 30px;
        }
      }
    }
  }
}
.footbox{
  width: 100%;

  background: #000;
  border-radius: 50px 50px 0px 0px;
  padding-top: 30px;
  padding-bottom: 30px;
  color: #fff;
  font-size: 16px;
  .footboxcard{
    width: 70%;
    margin-left: 15%;
    display: flex;
    justify-content: space-between;

    color: #fff;
    .footboxcarditem{
      img{
        vertical-align: middle;
      }
    }
  }
  .footcopy{
    margin-top: 50px;
    text-align: center;
  }
}
.reelbuzz-footer {
        width: 100%;
        overflow: hidden;
        box-sizing: border-box;
        background: #191A20;

        .footer-content {
            width: 1240px;
            height: 360px;
            margin: 0 auto;
            display: flex;;

            .footer-company {
                width: 570px;
                height: 100%;
                padding-top: 108px;
                box-sizing: border-box;

              .company-title {
                font-weight: 900;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 24px;
                margin-bottom: 23px;
              }

              .company-name {
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 28px;
              }
            }

            .footer-menu {
                width: 256px;
                height:100%;
                padding-top: 97px;
                box-sizing: border-box;

                .menu-title {
                  font-weight: 900;
                  font-size: 20px;
                  color: #FFFFFF;
                  line-height: 24px;
                  margin-bottom: 24px;
                }

                .menu-name {
                  font-weight: 400;
                  font-size: 14px;
                  color: #FFFFFF;
                  line-height: 28px;
                  cursor: pointer;
                }
            }

            .footer-contact {
              width: 410px;
              height: 100%;
              padding-top: 97px;
              box-sizing: border-box;

              .contact-title {
                font-weight: 900;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 24px;
                margin-bottom: 18px;
              }

              .contact-name-box {
                width: 410px;
                min-height:132px ;
                background: rgba(255,255,255,0.1);
                border-radius: 12px;
                padding: 10px 12px;
                box-sizing: border-box;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 28px;
              }
            }
        }


    }
</style>
